import { buildQueryParams } from "utils";
import { DocumentsQuery } from "./types";

export const DOCUMENTS_API_PATHS = {
  DOCUMENTS: (query?: DocumentsQuery) => {
    const baseUrl = "/documents";

    if (!query) {
      return baseUrl;
    }

    return `${baseUrl}?${buildQueryParams(query)}`;
  },
  COMMON_DOCUMENTS: (query?: DocumentsQuery) => {
    const baseUrl = "/commondocuments";

    if (!query) {
      return baseUrl;
    }

    return `${baseUrl}?${buildQueryParams(query)}`;
  },
  DOCUMENTS_UPLOADED: "/documents/file-uploaded",
  COMMON_DOCUMENTS_UPLOADED: "/commondocuments/file-uploaded",
  DOCUMENT: (documentId: string) => `/documents/${documentId}`,
  EXPORT_DOCUMENTS: "/export/documents",
  GET_BILLS: (documentId: string) => `/documents/${documentId}/bills`,
  CREATE_BILL: (documentId: string) => `/documents/${documentId}/bill`,
};
